import React from 'react'
import { mergeProps } from 'src/util'
import styles from './Navbar.scss'

/**
 * A flex navbar component, useful in combination with NavbarItem or LinkNavbarItem.
 */
const Navbar = props => <div {...mergeProps()({ className: styles.navbar }, props)} />

export default Navbar
